export default __webpack_public_path__ + "static/media/CF-map.3c48b7ff.png";